<template>
  <div>
    <datatable
      title="Admin History Companies"
      @delete="deleteHistoryCompany"
      @create="createHistoryCompany"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-history-companies',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'name',
          value: 'name'
        },
        {
          name: 'description',
          value: 'description'
        }
      ],
      data: [],
      operations: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getAllHistoryCompanies().then(response => {
        this.data = response
      })
    },
    deleteHistoryCompany (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.name,
        item_name: delete_data.name,
        method: 'deleteHistoryCompany',
        method_params: { id: delete_data.id }
      })
    },
    createHistoryCompany () {
      this.create({ designator: 'admin-history-companies-form-modal', component_name: 'AdminHistoryCompaniesForm', is_create: true, modal_title: 'Create new History Company' })
    },
    editClick (data) {
      this.create({ designator: 'admin-history-companies-form-modal', component_name: 'AdminHistoryCompaniesForm', data, modal_title: data.name })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
